export default "__VITE_ASSET__fsOdkuu5__"